<template>
  <div class="sub-container">
    <v-card class="ml-3 mt-0" color="#433876" variant="flat" height="60px">
      <v-card-actions>
        <span class="mt-0 ml-2 head-sub-text">
          <v-icon class="mx-2">mdi-email</v-icon>All Emails</span>
        <v-spacer />
        <!-- 
        <v-btn
          color="purple"
          variant="flat"
          class="btn-text mr-3"
          size="small"
          :to="{ name: 'AddCampaign' }"
        >
          <span class="btn-text"
            ><v-icon class="mx-2">mdi-file-plus</v-icon>Add Campaign</span
          >
        </v-btn> -->
      </v-card-actions>
    </v-card>

    <v-card-actions class="">
      <div class="search-field px-2">
        <p>Campaign</p>

        <v-autocomplete v-model="formData.mail_campaign_id" :items="campaigns.length > 0 ? campaigns : []"
          class="mx-2 mt-3" color="blue-grey-lighten-2" item-title="subject" item-value="id" label="Select" chips
          closable-chips density="compact" style="color: #3c3731" variant="outlined"></v-autocomplete>
      </div>
      <div class="search-field px-2">
        <p class="mt-n2">Recipient</p>

        <v-text-field class="mx-2 my-2" v-model="formData.to_email" label="Search" variant="outlined" density="compact"
          hide-details style="color: #3c3731" />
        <!-- <v-text-field
          v-model="search"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          hide-details
          single-line
        /> -->
      </div>
      <div class="d-flex justify-space-between">
        <!-- <p>Sent</p> -->
        <div class="px-3">
          <v-chip size="small" :color="showSent ? 'green' : ''" :prepend-icon="showSent ? 'mdi-check' : ''"
            @click="addFilter('sent')">
            Sent
          </v-chip>
        </div>

        <div class="px-2">
          <v-chip size="small" :color="showOp ? 'green' : ''" :prepend-icon="showOp ? 'mdi-check' : ''"
            @click="addFilter('opened')">
            Opened
          </v-chip>
        </div>
        <div class="px-2">
          <v-chip size="small" :color="showDel ? 'green' : ''" :prepend-icon="showDel ? 'mdi-check' : ''"
            @click="addFilter('delivered')">
            Delivered
          </v-chip>
        </div>
        <div class="px-2">
          <v-chip size="small" :color="showclicked ? 'green' : ''" :prepend-icon="showclicked ? 'mdi-check' : ''"
            @click="addFilter('clicked')">
            Clicked
          </v-chip>
        </div>
      </div>
      <v-spacer />

      <v-btn color="red" variant="flat" class="text-none" size="small" @click="submitFilters">
        <span class="btn-text">Search</span>
      </v-btn>

      <v-btn color="teal" variant="flat" class="text-none" prepend-icon="mdi-delete-empty" size="small"
        @click="clearFilters">
        <span class="btn-text">Clear Filters</span>
      </v-btn>
      <v-spacer />
       <v-card class=" mt-n3 mr-3" color="#fffff" variant="flat">
          <v-btn color="blue" variant="flat" class="text-none" size="small" @click="fetchAllSentemails">
            <span class="btn-text">Fetch All Emails</span>
          </v-btn></v-card>
       <v-card class=" mt-n3" color="#fffff" variant="flat">
          <v-btn color="green" variant="flat" class="text-none" size="small" @click="exportSummaryToExcel">
            <span class="btn-text">Export Summary</span>
          </v-btn>
        </v-card>
    </v-card-actions>

    <v-card variant="flat" class="ml-3">
      <v-data-table
        :items="emails.length > 0 ? emails : []"
        :headers="headers"
        item-value="id"
        :search="search"
        :hide-default-footer="false"
        :items-per-page="formData2.fetch_all ? (emails && emails.length ? emails.length : pageSize) : pageSize"
      >
        <template #[`item.campaign_name`]="{ item }">
          {{
            item.raw.campaign_name !== undefined
              ? item.raw.campaign_name
              : "Test "
          }}
        </template>

        <template #[`item.is_sent`]="{ item }">
          <v-chip :color="item.raw.status_code === '1000' ? 'green' : 'red'" variant="flat" size="x-small">
            <span class="chip-text">

              {{
                item.raw.status_code === "1000" ? "sent" : "failed"
              }}</span>
          </v-chip>
        </template>

        <template #[`item.is_clicked`]="{ item }">
          <v-chip :color="getColor(item.raw.is_clicked)" variant="flat" size="x-small">
            <span class="chip-text">{{
              item.raw.is_clicked ? "clicked" : "not clicked"
            }}</span>
          </v-chip>
        </template>

        <template #[`item.is_opened`]="{ item }">
          <v-chip :color="getColor(item.raw.is_opened)" variant="flat" size="x-small">
            <span class="chip-text">{{
              item.raw.is_opened ? "opened" : "unopened"
            }}</span>
          </v-chip>
        </template>

        <template #[`item.is_delivered`]="{ item }">
          <v-chip :color="item.raw.status_code === '1000' ? 'green' : 'orange'" variant="flat" size="x-small">
            <span class="chip-text">{{
              item.raw.status_code === "1000" ? "delivered" : "undelivered"
            }}</span>
          </v-chip>
        </template>

        <template #[`item.actions`]="{ item }">
          <!-- <v-menu>
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props"> mdi-dots-vertical</v-icon>
            </template>

<v-list>
  <v-list-item class="mt-n3" :to="{ name: 'AddList', params: { id: item.raw.id } }">
    <v-list-item-title class="list-title">Edit</v-list-item-title>
  </v-list-item>

  <v-list-item class="mt-n3" @click="deleteItem(item.raw.id)">
    <v-list-item-title class="list-title">Delete</v-list-item-title>
  </v-list-item>
</v-list>
</v-menu> -->

          <div class="d-flex align-center">
            <v-tooltip location="bottom" text="Edit">
              <template #activator="{ props: tooltipProps }">
                <v-icon v-bind="tooltipProps" class="cursor-pointer text-primary mx-6 ml-n2" @click="
                  $router.push({
                    name: 'AddList',
                    params: { id: item.raw.id },
                  })
                  ">
                  mdi-pencil
                </v-icon>
              </template>
            </v-tooltip>

            <v-tooltip location="bottom" text="Edit">
              <template #activator="{ props: tooltipProps }">
                <v-icon v-bind="tooltipProps" class="cursor-pointer text-primary mx-6 ml-n2"
                  @click="deleteItem(item.raw.id)">
                  mdi-delete
                </v-icon>
              </template>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-card-actions class="mt-n12">
        <v-spacer class="" />
        <!-- 
        <v-btn
          color="#38a4f8"
          variant="flat"
          class="text-none"
          size="small"
          @click="onPaginationNextChange"
        >
          <span class="btn-text">Prev</span>
        </v-btn>
        <div class="ml-n4"></div>

        <v-btn
          color="green"
          variant="flat"
          class="text-none"
          size="small"
          @click="onPaginationChange"
        >
          <span class="btn-text">Next</span>
        </v-btn> -->
        


       


        <v-card class=" mt-n3" color="#fffff" variant="flat">
        


          <PaginationControls :current-page="currentPage" :total-pages="pagination ? pagination.total_pages : 0"
            @page-changed="fetchSentemails" />


        </v-card>



        <!-- <div class="ml-12"></div> -->
      </v-card-actions>
    </v-card>
    <v-dialog v-model="loaderState" max-width="500">
      <v-card>
        <v-card-actions><v-spacer />Please Wait <v-spacer /></v-card-actions>
        <v-card-actions><v-spacer />
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>

          <v-spacer />
        </v-card-actions>

        <v-progress-linear class="mx-2 mt-n3" color="teal" indeterminate></v-progress-linear>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaginationControls from "@/utils/PaginationControls.vue";
export default {
  name: "ListDisplayPage",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("email/getPaginatedEmails", {});
      v.$store.dispatch("campaign/getCampaigns", v.campData);
    });
  },

  components: {
    PaginationControls,
  },

  data() {
    return {
      showSent: false,
      showOp: false,
      showDel: false,
      showclicked: false,
      offset: 0,
      dialog: true,
      groups: [],
      menu: false,
      menu2: false,
      menu3: false,
      search: "",
      isValid: false,
      loadingState: false,
      screenSize: "",
      oldValue: false,
      campData: {
        start_date: null,
        end_date: null,
        subject: null,
      },
      formData: {
        is_sent: false,
        is_clicked: false,
        is_delivered: false,
        is_opened: false,
        to_email: null,
        mail_campaign_id: null,
        page: null,
        offset: null,
        limit: null,
        current_page: null
      },

      formData2: {

        page: null,
        offset: null,
        limit: null,
        current_page: null,
        fetch_all:false
      },

      selected: [],

      headers: [
        {
          title: "Campaign",
          key: "campaign_name",
        },
        { title: "Recipient", key: "to_email" },

        {
          title: "Sent",
          key: "is_sent",
        },
        {
          title: "Opened",
          key: "is_opened",
        },
        {
          title: "Delieverd",
          key: "is_delivered",
        },
        {
          title: "Clicked",
          key: "is_clicked",
        },
        // {
        //     title: "No of Subscribers",
        //     key: "status",

        // },
        // { title: "Actions", key: "actions" },
      ],
    };
  },

  computed: {
    emails() {
      return this.$store.getters["email/emailGetters"]("emails");
    },
    subscribers() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "subscribers"
      );
    },
    loaderState() {
      return this.$store.getters["email/emailGetters"]("loaderState");
    },
    campaigns() {
      return this.$store.getters["campaign/campaignGetters"]("campaigns");
    },

    pagination() {
      return this.$store.getters["email/emailGetters"](
        "pagination"
      );
    },
    currentPage() {
      return this.pagination ? this.pagination.current_page : 1;
    },
    pageSize() {
      return this.pagination ? this.pagination.page_size : 10;
    },
    summaryCounts() {
      const emails = this.emails && Array.isArray(this.emails) ? this.emails : [];
      const total = emails.length;

      const sent = emails.filter((e) => {
        if (!e || !e.raw) return false;
        if (e.raw.status_code !== undefined && e.raw.status_code !== null)
          return String(e.raw.status_code) === "1000";
        if (e.raw.is_sent !== undefined) return !!e.raw.is_sent;
        return false;
      }).length;

      const clicked = emails.filter((e) => e && e.raw && (e.raw.is_clicked === true || String(e.raw.is_clicked) === 'true')).length;

      const delivered = emails.filter((e) => {
        if (!e || !e.raw) return false;
        if (e.raw.status_code !== undefined && e.raw.status_code !== null)
          return String(e.raw.status_code) === "1000";
        if (e.raw.is_delivered !== undefined) return !!e.raw.is_delivered;
        return false;
      }).length;

      const failed = total - sent;

      return { total, sent, failed, clicked, delivered };
    },
  },

  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
  },
  methods: {
    addFilter(filterType) {
      // Toggle the show state for the selected filter
      if (filterType === "sent") {
        this.showSent = !this.showSent;
        this.formData.is_sent = this.showSent; // Set to the current toggle state
      } else if (filterType === "opened") {
        this.showOp = !this.showOp;
        this.formData.is_opened = this.showOp; // Set to the current toggle state
      } else if (filterType === "delivered") {
        this.showDel = !this.showDel;
        this.formData.is_delivered = this.showDel; // Set to the current toggle state
      } else if (filterType === "clicked") {
        this.showclicked = !this.showclicked;
        this.formData.is_clicked = this.showclicked; // Set to the current toggle state
      }
    },

    async fetchSentemails(pageNumber) {
      console.log("Fetching subscribers for page:", pageNumber, this.pageSize);
      this.formData2.offset = 0; // Reset offset for new page fetch

      const offset = (pageNumber - 1) * this.pageSize;

      this.formData2.offset = offset; // Update the offset in formData
      this.formData2.limit = this.pageSize; // Update the limit in formData
      this.formData2.current_page = pageNumber; // Update the current page in formData

      this.$store.dispatch("email/getPaginatedEmails", this.formData2);
    },

      async fetchAllSentemails() {
    

      this.formData2.fetch_all = true; // Update the offset in formData
      // Update the current page in formData

      this.$store.dispatch("email/getPaginatedEmails", this.formData2);
    },


    submitFilters() {
      // Reset page to 1
      this.formData.page = 1;

      // Create a clean object with only the necessary fields
      const cleanData = {
        mail_campaign_id: this.formData.mail_campaign_id,
      };

      // Only add true boolean values
      if (this.formData.is_sent) cleanData.is_sent = true;
      if (this.formData.is_clicked) cleanData.is_clicked = true;
      if (this.formData.is_delivered) cleanData.is_delivered = true;
      if (this.formData.is_opened) cleanData.is_opened = true;

      // Only add non-null values
      if (this.formData.to_email) cleanData.to_email = this.formData.to_email;
      if (this.formData.page) cleanData.page = this.formData.page;

      // Dispatch the cleaned data
      this.$store.dispatch("email/getPaginatedEmails", cleanData);
    },
    clearFilters() {
      this.showSent = false;
      this.showOp = false;
      this.showDel = false;
      this.showclicked = false;
      this.formData = {
        is_sent: false,
        is_clicked: false,
        is_delivered: false,
        is_opened: false,
        to_email: null,
        mail_campaign_id: this.$route.params.id,
        page: null,
      };
      this.$store.dispatch(
        "email/getPaginatedEmails",
        this.formData
      );
    },



    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
    deleteItem(val) {
      alert("Are you sure you want to delete list ?");
      this.$store.dispatch("list/deleteList", parseInt(val));
    },

    getColor(val) {
      if (val) return "#46c35f";
      else return "orange";
    },
    changeAvatarColor(item) {
      // Change the color of the clicked avatar
      item.avatarProps.color = "red"; // Change to desired color
    },

    onPaginationChange() {
      // Update the offset state

      if (
        this.formData.to_email !== null ||
        this.formData.mail_campaign_id !== null ||
        this.formData.is_clicked ||
        this.formData.is_delivered ||
        this.formData.is_opened ||
        this.formData.is_sent
      ) {
        this.formData.page += 1;
        this.$store.dispatch("email/getFilteredEmails", this.formData);
      } else {
        this.offset += 10;
        this.$store.dispatch("email/getPaginatedEmails", this.offset);
      }
    },

  exportSummaryToExcel() {
  const emails = this.emails && Array.isArray(this.emails) ? this.emails : [];
  
  // Define headers
  const headers = [
    "Timestamp",
    "Recipient",
    "Subject",
    "Message ID",
    "Status",
    "Events",
    "Attachments"
  ];
  
  // Create data rows from emails
  const dataRows = emails.map((email) => {
    const raw = email.raw || {};
    
    // Format timestamp
    const timestamp = raw.created_at 
      ? new Date(raw.created_at).toISOString().slice(0, 10)
      : new Date().toISOString().slice(0, 10);
    
    // Get recipient
    const recipient = raw.to_email || "N/A";
    
    // Get subject (from campaign or email)
    const subject = raw.subject || raw.campaign_name || "N/A";
    
    // Get message ID (you might need to adjust this field name)
    const messageId = raw.message_id || raw.id || "N/A";
    
    // Determine status based on status_code or is_sent
    let status = "Failed";
    if (raw.status_code === "1000" || raw.status_code === 1000) {
      status = "Delivered";
    } else if (raw.is_sent) {
      status = "Delivered";
    }
    
    // Build events string
    const events = [];
    if (raw.is_opened) events.push("Opened");
    if (raw.is_clicked) events.push("Clicked");
    if (raw.is_delivered || raw.status_code === "1000") events.push("Delivered");
    const eventsStr = events.length > 0 ? events.join(", ") : "None";
    
    // Attachments (you might need to adjust this based on your data structure)
    const attachments = raw.attachments || raw.attachment_count || "0";
    
    return [
      timestamp,
      recipient,
      subject,
      messageId,
      status,
      eventsStr,
      attachments
    ];
  });
  
  // Combine headers and data
  const allRows = [headers, ...dataRows];
  
  // Convert to CSV
  const csvContent = allRows
    .map((row) => 
      row.map((cell) => {
        // Convert to string and escape double quotes
        const cellStr = String(cell).replace(/"/g, '""');
        return `"${cellStr}"`;
      }).join(",")
    )
    .join("\r\n");
  
  // Add BOM for proper UTF-8 encoding in Excel
  const csvWithBOM = "\uFEFF" + csvContent;
  
  // Create and download the file
  const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
  a.href = url;
  a.download = `email_campaign_report_${timestamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
},

    onPaginationNextChange() {
      // Update the offset state

      if (
        this.formData.to_email !== null ||
        this.formData.mail_campaign_id !== null ||
        this.formData.is_clicked ||
        this.formData.is_delivered ||
        this.formData.is_opened ||
        this.formData.is_sent
      ) {
        this.formData.page -= 1;
        this.$store.dispatch("email/getFilteredEmails", this.formData);
      } else {
        this.offset -= 10;
        this.$store.dispatch("email/getPaginatedEmails", this.offset);
      }
    },
  },

  watch: {
    loaderState: {
      handler: function (newValue, oldValue) {
        this.oldValue = oldValue;
        this.loadingState = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style>
@import url("../emailStyle.css");
</style>
